import { combineReducers } from 'redux';
import { getIdFromPayload, getResource } from '../utils';
import { merge } from 'lodash';
import { createSelector } from 'reselect';

const initialState = {
  loading: false,
  loaded: false,
  errors: {},
  page: 1,
  hasNextPage: true,
};

const resource = (state, { type, payload }) => {
  switch (type) {
    case 'STORE_RESOURCE_REQUEST':
      return {
        ...state,
        ...payload,
        loading: true,
      };
    case 'STORE_RESOURCE_SUCCESS':
    case 'STORE_RESOURCE_CREATE_SUCCESS':
      return merge({}, state, payload, { loading: false });
    case 'STORE_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        ...payload,
        loading: false,
      };
    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'STORE_RESOURCE_REQUEST':
    case 'STORE_RESOURCE_SUCCESS':
    case 'STORE_RESOURCE_CREATE_SUCCESS':
    case 'STORE_RESOURCE_UPDATE_SUCCESS': {
      const id = getIdFromPayload(payload);
      const resourcePayload = getResource('stores', payload, id);
      return {
        ...state,
        [id]: resource(state[id], { type, payload: resourcePayload }),
      };
    }
    case 'STORE_LIST_SUCCESS':
      return payload.entities.stores || {};
    default:
      return state;
  }
};

const common = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'STORE_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'STORE_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        loaded: true,
        page: state.page + 1,
        hasNextPage: payload.result.has_next_page,
      };
    case 'STORE_LIST_FAILURE':
    case 'STORE_RESOURCE_CREATE_FAILURE':
    case 'STORE_RESOURCE_UPDATE_FAILURE':
    case 'STORE_RESOURCE_SYNC_VALIDATION_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    case 'STORE_RESOURCE_REQUEST':
      return {
        ...state,
        errors: {},
      };
    case 'STORE_RESOURCE_SUCCESS':
    case 'STORE_RESOURCE_CREATE_SUCCESS':
    case 'STORE_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        errors: {},
      };
    case 'STORE_RESOURCE_CLEAR_VALIDATION':
      return {
        ...state,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

const defaultFilters = {
  data: {
    for_workrooms: [],
    for_divisions: [],
    for_regionss: [],
    for_marketss: [],
    all: true,
    query: null,
  },
  idsByFilter: [],
};

const defaultInstallerPrioritization = {
  installers: [],
  surfaceTypes: [],
  loading: false,
};

const installerPrioritization = (state = defaultInstallerPrioritization, { type, payload }) => {
  switch (type) {
    case 'STORE_INSTALLER_PRIORITIZATION_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'STORE_INSTALLER_PRIORITIZATION_SUCCESS':
      return {
        ...state,
        installers: payload.installers,
        surfaceTypes: payload.surfaceTypes,
        loading: false,
      };
    case 'STORE_INSTALLER_PRIORITIZATION_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'STORE_INSTALLER_PRIORITIZATION_RESET':
      return defaultInstallerPrioritization;
    default:
      return state;
  }
};

const filters = (state = defaultFilters, { type, payload }) => {
  switch (type) {
    case 'STORE_LIST_SUCCESS':
      return {
        ...state,
        idsByFilter: payload.result.stores,
      };
    case 'STORE_SET_FILTER':
      return {
        ...state,
        idsByFilter: [],
        data: { ...payload },
      };
    case 'STORE_RESET_FILTERS':
      return defaultFilters;
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  common,
  filters,
  installerPrioritization,
});

const getById = state => id => state.byId[id];
const getHasNextPage = state => state.common.hasNextPage;
const getPage = state => state.common.page;
const getLoading = state => state.common.loading;
const getLoaded = state => state.common.loaded;
const getErrors = state => state.common.errors;
const idsByFilter = state => state.filters.idsByFilter;
const getFiltersData = state => state.filters.data;
const getInstallerPrioritization = state => state.installerPrioritization;

const getList = createSelector(
  getById,
  idsByFilter,
  (lookup, list) => list.map(id => lookup(id)),
);

export { getList, getHasNextPage, getPage, getLoading, getLoaded, getErrors, getById,
  getFiltersData, getInstallerPrioritization };



// WEBPACK FOOTER //
// ./client/app/reducers/stores.js